// extracted by mini-css-extract-plugin
var _1 = "_pagination-module__container";
export { _1 as "container" }
